import { Container, Typography, Box } from '@mui/material';
import ReadMore from '@/components/ReadMore';
import { useResponsive } from '../hooks/useResponsive';

const JobDescription = ({ profileDesc }: { profileDesc: string }) => {
  const { isSmallViewport } = useResponsive();
  return (
    <Container maxWidth="md">
      <Box pt={2} pb={3}>
        <Typography variant="h2" mb={2}>
          About the job
        </Typography>
        {isSmallViewport ? (
          <ReadMore
            gutterBottom
            component="div"
            variant="body2"
            charLimit={155}
            value={profileDesc}
            showMoreLabel="more"
          />
        ) : (
          <Typography variant="body2">{profileDesc}</Typography>
        )}
      </Box>
    </Container>
  );
};

export default JobDescription;
